import { useEffect, useRef, useState } from 'react'

import { TextColorType } from '@ui/design-system/colors/colors'

const DEFAULT_COLOR: TextColorType = 'text-high-em'
const DEFAULT_DURATION_MS = 1000

export const usePriceColor = (
  value: number | null | undefined,
  durationMs = DEFAULT_DURATION_MS,
  defaultColor: TextColorType = DEFAULT_COLOR
): TextColorType => {
  const [color, setColor] = useState<TextColorType>(defaultColor)
  const prevRef = useRef<number | null>(null)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (typeof value !== 'number') {
      setColor(defaultColor)
      return
    }

    const prev = prevRef.current
    prevRef.current = value

    if (prev == null || prev === value) return

    const nextColor: TextColorType = value > prev ? 'text-success-high-em' : 'text-danger-high-em'

    setColor(nextColor)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setColor(defaultColor)
      timeoutRef.current = null
    }, durationMs)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [value, defaultColor])

  return color
}
